// Target pace — the pace at which remembering everything scores 100.
// Mirrors services/scoring.PACE on the backend (display only; the rating is
// always calculated server-side).
export const TARGET_SECONDS_PER_ITEM = { numbers: 1.5, words: 5, names: 6 };

export const TARGET_PER_ITEM_LABEL = {
  numbers: "1.5 seconds a digit",
  words: "5 seconds a word",
  names: "6 seconds a name",
};

const mmss = (seconds) => {
  const total = Math.round(seconds);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
};

export const targetMemorizeSeconds = (mode, itemsCount) =>
  (TARGET_SECONDS_PER_ITEM[mode] || 0) * (itemsCount || 0);

// "Target pace for 30 words is 2:30 (5 seconds a word) — beat it and you score above 100."
export const targetPaceLine = (mode, itemsCount, unit) => {
  const seconds = targetMemorizeSeconds(mode, itemsCount);
  if (!seconds) return null;
  return `Target pace for ${itemsCount} ${unit} is ${mmss(seconds)} (${TARGET_PER_ITEM_LABEL[mode]}) — beat it and you score above 100.`;
};

export const formatMmss = mmss;
